import { css } from 'linaria';

export const newKitchenReviewsBenefitsLink = css`
  border-bottom: 2px solid var(--control-accent);
`;

export const newKitchenReviewsLink = css`
  display: inline-block;
  border-bottom: 2px solid var(--control-accent);

  &:hover {
    background-color: var(--brand-dark);
    border-radius: var(--rounding-m) var(--rounding-m) 0 0;
  }
`;

export const newKitchenReviewsTitle = css`
  && {
    margin-bottom: 8px;
  }
`;
